/**
 * 【KYMW1400】コマ情報VO
 *
 * @export GoodsInfoModel
 * @class GoodsInfoModel
 */
export class GoodsInfoModel {
  /**
   * Pコード
   */
  public pCode = String('');

  /**
   * 掲載料請求枠数
   */
  public publishAmountLimitNum = Number(0);

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = String('01');

  /**
   * アイテムコード
   */
  public itemCode = String('');

  /**
   * 注文コード６桁
   */
  public orderNum6Digits = String('');

  /**
   * 受付開始受注コード
   */
  public receiptSOrderCode = String('');

  /**
   * 適用開始受注コード
   */
  public startOrderCode = String('');
}
